import { completedComponent } from './completed.component';

export const transferringCompletedStateName =
  'app.ticket.transferringCompleted';

export const transferringCompletedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: transferringCompletedStateName,
    url: '/completed',
    component: completedComponent.name,
    data: { requiresAuth: true },
    resolve: {
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const { ui } = appConfig;
        if (ui.v2UI.oldBank && !envService.isLocalhost()) {
          $window.location.href = $window.location.href.replace(
            '/tickets',
            '/v2/tickets',
          );
        }
      },
    },
  });
};

export const receivingCompletedStateName = 'app.ticket.receivingCompleted';

export const receivingCompletedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingCompletedStateName,
    url: '/completed',
    component: completedComponent.name,
    data: { requiresAuth: true },
  });
};
